<button
  *ngIf="job$ | async as job"
  mat-fab
  color="primary"
  type="button"
  class="push-fab"
  [style.--push-fab-slot]="slot"
  [class.terminal]="progress.isTerminal(job)"
  [attr.aria-label]="label(job)"
  [title]="label(job)"
  (click)="open()">
  <ng-container *ngIf="!progress.isTerminal(job); else terminalIcon">
    <mat-progress-spinner mode="determinate" diameter="48" strokeWidth="4" [value]="job.progressPercent"></mat-progress-spinner>
    <span>{{ job.progressPercent }}%</span>
  </ng-container>
  <ng-template #terminalIcon><mat-icon>{{ icon(job) }}</mat-icon></ng-template>
</button>
